import React, { useContext, useEffect } from 'react'
import { useIntl } from 'react-intl'
import HeadData from 'components/Common/HeadData'
import LayoutContainer from 'components/Common/LayoutContainer'
import TourSearchHeroContainer from 'components/Search/TourV2/TourSearchHeroContainer'
import { TOUR_V2_CATALOGUE_HERO_IMAGE_ID } from 'constants/tours'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import { useAppSelector } from 'hooks/reduxHooks'
import ModalContext from 'contexts/ModalContext'
import { selectLoggedIn } from 'selectors/accountSelectors'
import styled from 'styled-components'
import { rem } from 'polished'

const CatalogueWrapper = styled.div`
  height: ${rem(680)};
  width: 100%;
`

function TourCataloguePage() {
  const intl = useIntl()
  const isLoggedIn = useAppSelector(state => selectLoggedIn(state))
  const showModal = useContext(ModalContext)

  useEffect(() => {
    if (!isLoggedIn) {
      let closeModal: any
      showModal((resolve) => {
        closeModal = resolve
        return <AccountAccessModal initialMode="toursCatalogueLogin" dismissable={false} />
      })
      return () => {
        // unmounting, must've changed pages via back button or some other way
        // We need to close the 'login modal' as it's no longer applicable on other pages
        closeModal({ loggedIn: false })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const headTitle = intl.formatMessage({
    id: '1wZxgRg8q1',
    defaultMessage: 'Tours catalogue',
    description: 'Page title for the tours catalogue page',
  })

  const subtitle = intl.formatMessage({
    id: '9/Vap+i2nJ',
    defaultMessage: 'Discover expertly designed tours with more immersive experiences, more curated inclusions, and more value.',
    description: 'Subtitle for the tours catalogue hero section',
  })

  return <div>
    <HeadData title={headTitle} />
    <VerticalSpacer gap={56}>
      <TourSearchHeroContainer
        heroImageId={TOUR_V2_CATALOGUE_HERO_IMAGE_ID}
        title={<>Tours <i>Catalogue</i></>}
        subtitle={subtitle}
        gravity="center"
      />
      <LayoutContainer>
        <CatalogueWrapper>
          <iframe
            width="100%"
            height="100%"
            frameBorder="0"
            allow="clipboard-write"
            sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
            allowFullScreen
            src="https://e.issuu.com/embed.html?d=tour_the_world_with_us_issue_001&hideIssuuLogo=true&u=dreambyluxuryescapes"
          />
        </CatalogueWrapper>
      </LayoutContainer>
    </VerticalSpacer>
  </div>
}

export default TourCataloguePage
